



























import { defineComponent, PropType, ref } from '@vue/composition-api';
import TtamCreativeIframeDrawer from '@/components/creative/creative-iframe-drawer/index.vue';

const name = 'ttam-creative-music-carousel-music-editor';
type GetInitDataFunctionType = () => unknown;
export default defineComponent({
  name,
  components: {
    TtamCreativeIframeDrawer,
  },
  props: {
    top: {
      type: String,
      default: () => '',
    },
    getInitData: {
      type: Function as PropType<GetInitDataFunctionType>,
      required: true,
      default: () => () => ({}),
    },
    buttonHide: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, ctx) {
    const shouldEditorShow = ref(false);

    const handleClose = () => {
      shouldEditorShow.value = false;
    };

    const handleSuccess = data => {
      handleClose();
      ctx.emit('success', data);
    };

    const handleEditorShow = () => {
      shouldEditorShow.value = true;
    };

    return {
      handleClose,
      handleSuccess,
      shouldEditorShow,
      handleEditorShow,
    };
  },
});
